var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Fancybox',{attrs:{"options":{
    Carousel: {
      infinite: true,
    },
  }}},[_c('div',{staticClass:"relative mt-s40"},[_c('a',{attrs:{"data-fancybox":"gallery","href":_vm.thumbnail}},[_c('img',{attrs:{"src":_vm.thumbnailLarge,"width":"420","height":"637","alt":_vm.alt}})]),_vm._v(" "),_c('div',{staticClass:"absolute text-center text-white -top-s5 -right-s5 w-fit grid gap-s5"},_vm._l((_vm.stickers),function(item,index){return _c('div',{key:index,staticClass:"py-s3 text-t12 uppercase rounded-md w-s140",class:'sticker-' + item.sticker_color},[_vm._v("\n          "+_vm._s(item.title))])}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }